import {get} from "./thunks";
import {initialState} from "./initial-state";
import {createSlice} from "@reduxjs/toolkit";
import {setRequestStatus} from "../request-status";

export const home = createSlice({
  name: "home",
  initialState,
  reducers: {},
  extraReducers: function (builder) {
    builder.addCase(get.fulfilled, function (state, action) {
      state["charts"] = action["payload"];
      state["request"]["charts"] = setRequestStatus("success");
    });
    builder.addCase(get.rejected, function (state) {
      state["request"]["charts"] = setRequestStatus("error");
    });
  },
});

export default home["reducer"];
